import Condiciones from './Condiciones';

export default Condiciones;
